import React from 'react';

const UploadIcon = ({ size, color, rotation }) => {
  return (
    <svg width='35' height='35' viewBox='0 0 24 24' fill='none'>
      <path
        d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'
        stroke='#1d9bf0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <polyline
        points='14,2 14,8 20,8'
        stroke='#1d9bf0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <line x1='16' y1='13' x2='8' y2='13' stroke='#1d9bf0' strokeWidth='2' strokeLinecap='round' />
      <line x1='12' y1='17' x2='12' y2='9' stroke='#1d9bf0' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export default UploadIcon;
